import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getSubjectList } from '@/api/modules/study.js';
import { queryNewUnlockTasks as _queryNewUnlockTasks } from '@/api/review.js';
export default {
  name: 'Subject',
  props: {
    subjectCode: {
      // 如果传入科目，就用传入的
      type: Number,
      default: 0
    },
    isShowTip: {
      // 如果有复习内容，右上角红点提示
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      active: '',
      subjects: [],
      subjectCodes: [],
      edu: JSON.parse(localStorage.getItem('userInfo')).edu || 3,
      tipCodes: []
    };
  },
  computed: _objectSpread({
    isFromReview: function isFromReview() {
      console.log(this.$route.path.includes('/review'));
      return this.$route.path.includes('/review');
    }
  }, mapGetters({
    userMode: 'userMode'
  })),
  watch: {
    subjectCode: function subjectCode(val) {
      this.active = val;
    },
    'userMode': function userMode() {
      this.init();
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.tipCodes = [];
                _this.subjectCodes = [];
                _context.next = 4;
                return _this.getSubjectList();

              case 4:
                if (!_this.isShowTip) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this.queryNewUnlockTasks();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    requestSubjects: function requestSubjects() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$getSubjectList, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getSubjectList({
                  edu: _this2.edu,
                  needAll: false // 改为false

                });

              case 2:
                _yield$getSubjectList = _context2.sent;
                status = _yield$getSubjectList.status;
                data = _yield$getSubjectList.data;

                if (!(status !== 1)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", []);

              case 7:
                if (!data || data.length === 0) {
                  // this.$emit('inactivated') 一个学科没有，直接去激活页
                  _this2.userMode === 'normal' && _this2.$router.push({
                    path: '/active'
                  });
                }

                return _context2.abrupt("return", data);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getSubjectList: function getSubjectList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data, subject;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.requestSubjects();

              case 2:
                data = _context3.sent;
                _this3.subjects = data;
                subject = _this3.subjectCode ? data.find(function (item) {
                  return item.code === _this3.subjectCode;
                }) : data[0];

                _this3.handleClick(subject, true);

                if (_this3.isShowTip) {
                  data.forEach(function (item) {
                    _this3.subjectCodes.push(item.code);
                  });
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    queryNewUnlockTasks: function queryNewUnlockTasks() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$_queryNewUnloc, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _queryNewUnlockTasks({
                  edu: _this4.edu,
                  subjectIdList: _this4.subjectCodes
                });

              case 2:
                _yield$_queryNewUnloc = _context4.sent;
                status = _yield$_queryNewUnloc.status;
                data = _yield$_queryNewUnloc.data;

                if (!(status !== 1)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return");

              case 7:
                data.forEach(function (item) {
                  var subjectId = item.subjectId,
                      flag = item.flag;

                  if (flag) {
                    _this4.tipCodes.push(subjectId);
                  }
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleClick: function handleClick(subject, noRequest) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _subject;

        var code;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                code = (_subject = subject) === null || _subject === void 0 ? void 0 : _subject.code;

                if (!(!subject || code !== _this5.active)) {
                  _context5.next = 8;
                  break;
                }

                if (noRequest) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return _this5.requestSubjects();

              case 5:
                if (!subject || _this5.subjects.every(function (sub) {
                  return sub.code !== code;
                })) {
                  subject = _this5.subjects[0] || {};
                }

                _this5.active = subject.code;

                _this5.$emit('switchSubject', subject.code, subject);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    judgeTip: function judgeTip(item) {
      return this.tipCodes.includes(item.code);
    }
  }
};